import { Link } from "react-router-dom";
import { Star, MapPin, Quote } from "lucide-react";

const testimonials = [
  { name: "Carlos & Mariana", location: "Santos, SP", initials: "CM", trip: "Lua de Mel nas Maldivas", text: "Atendimento simplesmente impecável! A equipe da Mahlo Viagens cuidou de cada detalhe da nossa lua de mel, desde a escolha do resort até os passeios de mergulho. Voltamos completamente apaixonados e cheios de memórias incríveis. Com certeza voltaremos a usar os serviços deles!" },
  { name: "Ana Paula Ferreira", location: "São Paulo, SP", initials: "AP", trip: "Europa em 15 dias", text: "Melhor experiência de viagem que já tive em toda a vida! A Mahlo personalizou cada parte do meu roteiro pela Europa com muita atenção e carinho. Todos os hotéis eram perfeitos, os transfers pontuais e o suporte durante a viagem foi excepcional. Recomendo a todos!" },
  { name: "Lucas & Thiago", location: "Santos, SP", initials: "LT", trip: "Romantismo em Paris", text: "Como casal LGBTQ+, sempre fomos muito seletivos na escolha da agência. Na Mahlo Viagens nos sentimos totalmente acolhidos e respeitados desde o primeiro contato. A viagem para Paris foi simplesmente perfeita: hotel boutique incrível e jantar na Torre Eiffel!" },
  { name: "Maria Beatriz Santos", location: "Campinas, SP", initials: "MB", trip: "Primeira viagem internacional", text: "Era minha primeira viagem internacional e estava muito ansiosa. A equipe da Mahlo foi incrível: me explicou tudo sobre vistos, documentação, câmbio e me deu dicas preciosas. O suporte durante a viagem foi fundamental! Já estou planejando a próxima com eles." },
  { name: "Paulo Henrique", location: "Santos, SP", initials: "PH", trip: "Cancún em família", text: "Levamos a família toda para Cancún — adultos e crianças — e foi uma organização impecável. A Mahlo encontrou um resort que agradou a todos. Preço justo, atendimento excelente e viagem inesquecível. Parabéns!" },
  { name: "Fernanda & Ricardo", location: "São Paulo, SP", initials: "FR", trip: "Cruzeiro pelo Mediterrâneo", text: "A Mahlo nos presenteou com uma viagem dos sonhos! O cruzeiro pelo Mediterrâneo foi simplesmente surreal. Eles cuidaram de absolutamente tudo. Qualidade excepcional em tudo. Já reservamos a próxima viagem com eles!" },
  { name: "Juliana Costa", location: "Santos, SP", initials: "JC", trip: "Aventura nos Alpes Suíços", text: "Sempre sonhei em ver os Alpes nevados e a Mahlo tornou isso realidade! O roteiro era perfeito: Zurique, Lucerna, Interlaken e Zermatt. Cada hotel tinha uma vista mais linda que o anterior. Atendimento de primeira qualidade. Nota mil!" },
  { name: "Roberto Almeida", location: "Guarujá, SP", initials: "RA", trip: "Dubai de Luxo", text: "Fui a Dubai em viagem de negócios combinada com turismo e a Mahlo foi perfeita. Hotel 5 estrelas, transfers executivos, tour pelo deserto e restaurante panorâmico no Burj Khalifa. Profissionalismo e excelência em cada detalhe. Parabéns à toda equipe!" },
];

const Testimonials = () => (
  <div data-testid="testimonials-page" className="pt-16 md:pt-20">
    <section className="page-hero flex items-center justify-center min-h-[350px] relative overflow-hidden">
      <div
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{
            backgroundImage:
              "url(https://images.pexels.com/photos/33288110/pexels-photo-33288110.jpeg)",
          }}
        />
      <div className="relative z-10 text-center text-white px-4">
        <p className="text-[#89A6A3] font-semibold tracking-widest text-sm uppercase mb-3">O que dizem sobre nós</p>
        <h1 className="font-heading text-4xl md:text-6xl font-bold">Depoimentos</h1>
        <p className="mt-4 text-white/80 text-lg max-w-xl mx-auto">Histórias reais de quem viveu experiências extraordinárias com a Mahlo Viagens.</p>
      </div>
    </section>

    <section data-testid="rating-summary-section" className="bg-white py-12 border-b border-slate-100">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <div className="flex justify-center items-center gap-2 mb-2">
          {[...Array(5)].map((_, i) => <Star key={i} size={28} className="fill-yellow-400 text-yellow-400" />)}
        </div>
        <p className="text-5xl font-bold text-[#2E4E72] font-heading">5.0</p>
        <p className="text-slate-600 mt-2">Avaliação média baseada em mais de 200 clientes satisfeitos</p>
        <div className="grid grid-cols-3 gap-6 mt-8 max-w-lg mx-auto">
          {[["Atendimento","100%"],["Qualidade","100%"],["Custo-benefício","98%"]].map(([label, pct]) => (
            <div key={label} className="text-center">
              <p className="text-2xl font-bold text-[#89A6A3]">{pct}</p>
              <p className="text-slate-500 text-xs mt-1">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section data-testid="testimonials-grid-section" className="py-20 md:py-28 bg-[#F4F7F6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {testimonials.map((t) => (
            <div key={t.name} data-testid={`testimonial-${t.name.toLowerCase().replace(/\s+&?\s*/g, '-')}`}
              className="bg-white p-8 rounded-2xl shadow-sm card-hover border border-slate-100 flex flex-col relative">
              <Quote size={32} className="text-[#B0CAC5] absolute top-6 right-6" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-yellow-400 text-yellow-400" />)}
              </div>
              <span className="text-xs text-[#2E4E72] font-semibold bg-[#B0CAC5]/40 px-3 py-1 rounded-full w-fit mb-4">{t.trip}</span>
              <p className="text-slate-600 leading-relaxed flex-1 italic text-sm">"{t.text}"</p>
              <div className="flex items-center gap-3 mt-6 pt-4 border-t border-slate-100">
                <div className="w-11 h-11 bg-[#2E4E72] rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0">{t.initials}</div>
                <div>
                  <p className="font-bold text-[#2E4E72]">{t.name}</p>
                  <p className="text-slate-400 text-xs flex items-center gap-1"><MapPin size={10} /> {t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-[#2E4E72] py-20 text-center">
      <div className="max-w-3xl mx-auto px-4">
        <div className="flex justify-center gap-1 mb-4">
          {[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-yellow-400 text-yellow-400" />)}
        </div>
        <h2 className="font-heading text-4xl font-bold text-white mb-4">Faça parte desta história</h2>
        <p className="text-white/75 text-lg mb-8">Junte-se a milhares de viajantes satisfeitos e viva sua próxima aventura com a Mahlo Viagens.</p>
        <Link to="/contato" data-testid="testimonials-cta-btn"
          className="bg-[#89A6A3] text-[#2E4E72] font-bold px-10 py-4 rounded-full text-lg hover:bg-[#6B8C89] hover:text-white hover:scale-105 transition-all duration-300 inline-block">
          Planejar Minha Viagem
        </Link>
      </div>
    </section>
  </div>
);

export default Testimonials;
